<compartido-ficha [configuracion]="configFicha" *ngIf="orden">
  <div
    class="orden borde mat-app-background {{
      responsiveService.claseCSS$ | async
    }}"
  >
    <mat-list>
      <ng-container *ngIf="orden.estado === EstadoOrden.POR_PREPARAR">
        <!-- Detalles -->
        <mat-list-item>
          <mat-icon matListItemIcon>receipt</mat-icon>
          <h3 matListItemTitle>ID Orden</h3>
          <p matListItemLine>{{ orden.id }}</p>
        </mat-list-item>
        <mat-list-item *ngIf="orden.referencia">
          <mat-icon matListItemIcon>numbers</mat-icon>
          <h3 matListItemTitle>No. Referencia</h3>
          <p matListItemLine>{{ orden.referencia }}</p>
        </mat-list-item>
        <mat-list-item>
          <mat-icon matListItemIcon>today</mat-icon>
          <h3 matListItemTitle>Fecha de Creación</h3>
          <p matListItemLine>{{ orden.fechaCreacion }}</p>
        </mat-list-item>
        <mat-list-item>
          <mat-icon matListItemIcon>person</mat-icon>
          <h3 matListItemTitle>Cliente</h3>
          <p matListItemLine>
            {{ orden.cliente.nombre }} - {{ orden.cliente.identificacion }}
          </p>
        </mat-list-item>

        <mat-divider *ngIf="(orden?.items ?? []).length > 0"></mat-divider>

        <!-- Items -->
        <mat-list-item
          *ngFor="let item of orden?.items; let i = index"
          class="item"
        >
          <mat-icon matListItemIcon>medication_liquid</mat-icon>
          <h3 matListItemTitle>Medicamento #{{ i + 1 }}</h3>
          <p matListItemLine>
            {{ item.producto.nombre }} <b>x{{ item.cantidad }}</b>
          </p>
        </mat-list-item>

        <mat-divider *ngIf="(orden?.formulas ?? []).length > 0"></mat-divider>

        <!-- Fórmulas -->
        <mat-list-item
          *ngFor="let formula of orden?.formulas; let i = index"
          class="formula"
        >
          <mat-icon matListItemIcon>medical_services</mat-icon>
          <h3 matListItemTitle>Fórmula #{{ i + 1 }}</h3>
          <p matListItemLine>
            <span class="ref" *ngIf="formula.referencia">
              Ref. {{ formula.referencia }}
            </span>
            <a [href]="formula.archivo" target="_blank" *ngIf="formula.archivo"
              >Archivo</a
            >
          </p>
        </mat-list-item>
      </ng-container>

      <mat-divider
        *ngIf="orden.fechaAplazamiento !== null || orden.antecesora"
      ></mat-divider>

      <!-- Alertas -->
      <mat-list-item *ngIf="orden.aplazadaHasta !== null">
        <mat-icon matListItemIcon class="color-warn">warning_amber</mat-icon>
        <h3 matListItemTitle class="color-warn">¡Orden Aplazada!</h3>
        <p matListItemLine>
          Esta orden fue aplazada el
          {{ orden.fechaAplazamiento | date: FORMATO_FECHA_PIPE }}
        </p>
      </mat-list-item>
      <mat-list-item *ngIf="orden.antecesora">
        <mat-icon matListItemIcon class="color-warn">warning_amber</mat-icon>
        <h3 matListItemTitle>¡Orden Sucesora!</h3>
        <p matListItemLine>
          Esta orden fue creada a raíz de una preparación parcial de la orden
          #{{ orden.antecesora }}
        </p>
      </mat-list-item>
    </mat-list>
  </div>

  <!-- Formulario -->
  <compartido-formulario
    class="formulario"
    [configuracion]="configFormulario"
    (valores)="valorFormulario = $event"
    (valido)="validezFormulario = $event"
  ></compartido-formulario>

  <!-- Cliente y Dirección -->
  <ng-container *ngIf="orden.cliente.organizacion.ordenes_sin_direccion">
    <div
      class="validar"
      *autorizacion="{ permisos: { cliente: [Permiso.EDITAR] } }"
    >
      <div class="cliente borde">
        <h3>Validar Cliente</h3>

        <clientes-datos-cliente
          [idCliente]="orden.cliente.id"
          [edicion]="'activada'"
        ></clientes-datos-cliente>
      </div>

      <div class="direccion borde">
        <h3>Validar Dirección</h3>

        <clientes-datos-direccion
          [idDireccion]="orden.direccion.id"
          [edicion]="'activada'"
        ></clientes-datos-direccion>
      </div>
    </div>
  </ng-container>

  <!-- Domicilio -->
  <div
    class="domicilio borde"
    *ngIf="
      valorFormulario?.['accion'] === AccionPrepararOrden.PREPARAR ||
      valorFormulario?.['accion'] === AccionPrepararOrden.PREPARAR_PARCIAL
    "
  >
    <h3>Domicilio</h3>

    <compartido-formulario
      [configuracion]="configFormularioDomicilio"
      (valores)="valorFormularioDomicilio = $event"
      (valido)="validezFormularioDomicilio = $event"
    ></compartido-formulario>
  </div>

  <!-- Orden Sucesora -->
  <div
    class="orden-sucesora borde"
    *ngIf="valorFormulario?.['accion'] === AccionPrepararOrden.PREPARAR_PARCIAL"
  >
    <h3>Orden Sucesora</h3>
    <p>
      Se creará una nueva orden complementaria que incluirá únicamente los ítems
      no preparados.
    </p>

    <div class="opcion">
      <p>
        <b>Opción 1:</b> Ingresa los items <b>NO PREPARADOS</b> manualmente:
      </p>

      <div
        class="item"
        *ngFor="let configuracion of configFormulariosItems; let i = index"
      >
        <compartido-formulario
          [configuracion]="configuracion"
          (valores)="valoresFormulariosItems[i] = $event"
          (valido)="validezFormulariosItems[i] = $event"
        ></compartido-formulario>
        <button mat-icon-button (click)="eliminarItem(i)" color="warn">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <button
        mat-flat-button
        color="secondary"
        (click)="agregarItem()"
        class="boton-agregar"
      >
        Agregar Item <mat-icon>add</mat-icon>
      </button>
    </div>

    <div class="opcion">
      <p>
        <b>Opción 2:</b> Adjunta la formula con los items <b>NO PREPARADOS</b>:
      </p>

      <div class="formulario-formula">
        <compartido-formulario
          [configuracion]="configFormularioFormula"
          (valores)="valorFormularioFormula = $event"
          (valido)="validezFormularioFormula = $event"
        ></compartido-formulario>
      </div>
    </div>
  </div>

  <div class="botones">
    <button
      mat-flat-button
      color="primary"
      tabindex="-1"
      [class.cargando]="cargando()"
      [disabled]="
        cargando() ||
        !validezFormulario ||
        (valorFormulario['accion'] === AccionPrepararOrden.PREPARAR_PARCIAL &&
          !validezItems &&
          !validezFormularioFormula) ||
        (validezItems && validezFormularioFormula) ||
        (valorFormulario['accion'] === AccionPrepararOrden.PREPARAR_PARCIAL &&
          !validezFormularioDomicilio) ||
        (valorFormulario['accion'] === AccionPrepararOrden.PREPARAR &&
          !validezFormularioDomicilio)
      "
      (click)="realizarAccion()"
    >
      Confirmar <mat-icon>done</mat-icon>
    </button>
  </div>
</compartido-ficha>

<div class="cargando" *ngIf="cargando()">
  <mat-spinner diameter="50"></mat-spinner>
</div>

<div class="sin-datos" *ngIf="!cargando() && orden === undefined">
  <mat-icon>info</mat-icon>
  <span>No se encontraron datos de la orden.</span>
</div>
